<template>
  <router-link to="/live" class="block relative h-screen overflow-hidden bg-black">
    <div class="uppercase text-2xl f-serif text-white border px-6 py-2 rounded-full border-white absolute top-0 right-0 mr-8 flex items-center z-10" :class="pillClasses">
      <span class="bg-red-600 rounded-full h-5 w-5 inline-block mr-5 pulse"></span><span class="inline-block pt-1">Live</span>
    </div>
    <router-link to="/home">
      <div v-if="full" class="uppercase text-2xl f-serif text-white border px-6 py-2 rounded-full border-white absolute top-0 left-0 ml-8 flex items-center z-10" :class="pillClasses">Home</div>
    </router-link>
    <div v-if="!full" class="text-white absolute bottom-0 right-0 mb-20 mr-8 z-10 text-right uppercase leading-none">
      <div class="mb-6 f-serif">Watch Now</div>
      <span class="text-4xl pl-6 text-right">{{ content.livestream_title }}</span>
    </div>
    <div class="iframe-container">
      <iframe v-if="content" class="" :class="iframeClasses" :src="url" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allowFullScreen="true"></iframe>
    </div>
  </router-link>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'Live',
    computed: {
      ...mapState(['content']),
      url () {
        let components = this.content.livestream_link.split('/')
        return `https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2F${components[3]}%2Fvideos%2F${components[5]}%2F&show_text=0`
      },
      full () {
        return this.$route.name === "live"
      },
      iframeClasses () {
        if (this.full) {
          return ""
        } else {
          return "home pointer-events-none w-screen h-screen absolute top-0 right-0 z-0"
        }
      },
      pillClasses () {
        if (this.full) {
          return "mt-8"
        } else {
          return "mt-24"
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>

.text-big
  font-size: 3vw

.pulse
  animation: pulse 2s infinite

@keyframes pulse
  0%
    opacity: 1
  50%
    opacity: 0.5
  100%
    opacity: 1

.iframe-container
  padding-bottom: 177.78%
  height: 100vh
  position: relative

iframe
  position: absolute;
  top: 0
  bottom: 0
  height: 100%
  border: 0
  left: 36vw
  width: calc(100vh * 9 / 16 - 24px)

iframe.home
  position: absolute
  top: -50vh
  bottom: 0
  height: 100%
  border: 0
  left: 0
  width: 50vw

</style>
